import { I18nString } from '@models/i18n/i18n-string';
import { BinaryFile } from './binary-file';
import { I18nStringMap } from './i18n/i18n-string-map';
import { User } from './user';

export class HtmlTemplate {

    id: string;
    templateName: string;
    description: string;
    locationValue: string;
    status: string;
    htmlTemplateImage:BinaryFile;

    locationList: string[];
    editable:boolean;

    forMerchantListString: string;


    constructor() {
        
        // this.templateFileName = new I18nStringMap();
        // let en = new I18nString();
        // let zh_tw = new I18nString();
        // let zh_cn = new I18nString();
        // en.locale = 'en';
        // zh_tw.locale = 'zh_TW';
        // zh_cn.locale = 'zh_CN';

        // this.templateFileName.i18nStrings = [];
        // this.templateFileName.i18nStrings.push(en);
        // this.templateFileName.i18nStrings.push(zh_tw);
        // this.templateFileName.i18nStrings.push(zh_cn);
    }

    public getLocationList(): string[]{
        if(!this.locationList)
        this.locationList = this.locationValue.split(",");

        return this.locationList;
    }

    static search(term: string, item: HtmlTemplate) {
        term = term.toLocaleLowerCase();
        return true;//item.templateFileName.i18nStrings.findIndex(name => name.value.toLocaleLowerCase().indexOf(term) > -1) > -1;
        // return  item.templateFileName.toLocaleLowerCase().indexOf(term) > -1;
    }
}


export class  HtmlTemplateSearchingCriteria{
    templateName: string;   
    locationCode: string;
    description: string;
}
